export default "__VITE_ASSET__DPSnu6mx__"